<template>
<svg :width="size" :height="size" viewBox="0 0 16 16" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <circle :cx="size / 2" :cy="size / 2" r="3.2" :fill="color"/>
</svg>
</template>
  
<script>
    export default {
        props: {
            size: {
                type: String,
                default: '16'
            },
            color: {
                type: String,
                default: ''
            },
        }
    }
</script>